const impersonationAlertStyles = {
  panel: {
    padding: '12px 16px 14px',
    background: '#B3261E',
    borderTop: '1px solid #8C1D17',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  collapsed: {
    padding: '10px 0',
    background: '#B3261E',
    borderTop: '1px solid #8C1D17',
    color: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
  },
  eyebrow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 12,
    fontWeight: 700,
    color: '#FFFFFF',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
  eyebrowIcon: {
    fontSize: 15,
  },
  user: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    minWidth: 0,
  },
  name: {
    fontSize: 15,
    fontWeight: 500,
    color: '#FFFFFF',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  email: {
    fontSize: 13,
    color: '#FCE8E6',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  stop: {
    alignSelf: 'flex-start',
    height: 40,
    padding: '0 14px',
    border: 0,
    background: '#FFFFFF',
    color: '#8C1D17',
    font: '500 14px Roboto, sans-serif',
    cursor: 'pointer',
    '&:hover': {
      background: '#FCE8E6',
    },
  },
}

export default impersonationAlertStyles
